import styled from 'styled-components';

export const Base = styled.div`
	.ProseMirror {
		outline: none;
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
			'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
		color: ${({ theme }) => theme.gray[800]};
		line-height: 1.7;
		font-size: 15px;
		user-select: text;

		h1 {
			font-size: 32px;
			font-weight: 700;
			line-height: 1.2;
			margin: 0 0 24px 0;
			color: ${({ theme }) => theme.gray[800]};
			letter-spacing: -0.02em;
			padding-bottom: 12px;
			border-bottom: 2px solid ${({ theme }) => theme.gray[800]};
		}

		h2 {
			font-size: 24px;
			font-weight: 600;
			line-height: 1.3;
			margin: 40px 0 16px 0;
			color: ${({ theme }) => theme.gray[800]};
			letter-spacing: -0.01em;

			&:first-child {
				margin-top: 0;
			}
		}

		h3 {
			font-size: 19px;
			font-weight: 600;
			line-height: 1.4;
			margin: 32px 0 12px 0;
			color: ${({ theme }) => theme.gray[600]};

			&:first-child {
				margin-top: 0;
			}
		}

		h4 {
			font-size: 16px;
			font-weight: 600;
			line-height: 1.5;
			margin: 24px 0 8px 0;
			color: ${({ theme }) => theme.gray[600]};

			&:first-child {
				margin-top: 0;
			}
		}

		p {
			margin: 0 0 16px 0;
			color: ${({ theme }) => theme.gray[600]};
			line-height: 1.5;

			&:last-child {
				margin-bottom: 0;
			}
		}

		a {
			color: ${({ theme }) => theme.blue[300]};
			text-decoration: none;
			border-bottom: 1px solid ${({ theme }) => theme.blue[600]};
			transition: all 0.15s ease;
			font-weight: 500;

			&:hover {
				color: ${({ theme }) => theme.blue[300]};
				border-bottom-color: ${({ theme }) => theme.blue[300]};
				background-color: ${({ theme }) => theme.blue[700]};
			}
		}

		ul {
			margin: 0 0 20px 0;
			padding-left: 28px;
			list-style-type: disc;

			ul {
				margin: 8px 0;
				list-style-type: circle;
			}
		}

		ol {
			margin: 0 0 20px 0;
			padding-left: 28px;

			ol {
				margin: 8px 0;
			}
		}

		li {
			margin: 0 0 8px 0;
			padding-left: 8px;
			color: ${({ theme }) => theme.gray[600]};
			line-height: 1.7;

			&:last-child {
				margin-bottom: 0;
			}

			p {
				margin-bottom: 8px;
			}
		}

		blockquote {
			margin: 24px 0;
			padding: 16px 20px;
			background-color: ${({ theme }) => theme.blue[700]};
			border-left: 4px solid ${({ theme }) => theme.blue[500]};
			border-radius: 0 6px 6px 0;
			color: ${({ theme }) => theme.gray[600]};

			p {
				margin: 0;
				color: ${({ theme }) => theme.gray[600]};
			}

			p:first-child {
				font-weight: 500;
			}

			code {
				background-color: ${({ theme }) => theme.blue[700]};
				border-color: ${({ theme }) => theme.blue[700]};
			}
		}

		code {
			display: inline;
			background-color: ${({ theme }) => theme.white};
			color: ${({ theme }) => theme.gray[800]};
			padding: 6px 6px;
			border-radius: 4px;
			font-size: 13px;
			font-family: 'SF Mono', 'Monaco', 'Menlo', 'Consolas', 'Courier New', monospace;
			font-weight: 500;
			border: 1px solid ${({ theme }) => theme.gray[100]};
		}

		pre {
			background-color: ${({ theme }) => theme.white};
			color: ${({ theme }) => theme.gray[800]};
			padding: 20px;
			border-radius: 8px;
			margin: 20px 0;
			overflow-x: auto;
			font-size: 13px;
			line-height: 1.6;
			font-family: 'SF Mono', 'Monaco', 'Menlo', 'Consolas', 'Courier New', monospace;
			border: 1px solid ${({ theme }) => theme.gray[100]};

			code {
				display: block;
				background: none;
				padding: 0;
				border-radius: 0;
				font-size: inherit;
				color: inherit;
				border: none;
				font-weight: normal;
			}
		}

		table {
			width: 100%;
			border-collapse: collapse;
			font-size: 14px;
			margin: 24px 0;
			border-radius: 8px;
			border: 1px solid ${({ theme }) => theme.gray[800]};
			overflow: hidden;

			thead {
				background-color: ${({ theme }) => theme.gray[800]};
				border-bottom: 2px solid ${({ theme }) => theme.gray[800]};

				th {
					padding: 12px 16px;
					text-align: left;
					font-weight: 600;
					color: ${({ theme }) => theme.gray[600]};
					font-size: 13px;
					text-transform: uppercase;
					letter-spacing: 0.05em;
				}
			}

			tbody {
				tr {
					border-bottom: 1px solid ${({ theme }) => theme.gray[800]};
					transition: background-color 0.1s ease;

					&:hover {
						background-color: ${({ theme }) => theme.gray[800]};
					}

					&:last-child {
						border-bottom: none;
					}
				}

				td {
					padding: 12px 16px;
					color: ${({ theme }) => theme.gray[600]};
					line-height: 1.6;
				}
			}

			code {
				font-size: 12px;
			}
		}

		hr {
			border: none;
			border-top: 1px solid ${({ theme }) => theme.gray[800]};
			margin: 32px 0;
		}
	}

	.ProseMirror p.is-editor-empty:first-child::before {
		content: attr(data-placeholder);
		color: ${({ theme }) => theme.gray[400]};
		pointer-events: none;
		float: left;
		height: 0;
	}
`;
